"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    pinInputVariants: function() {
        return pinInputVariants;
    },
    pinInputSizes: function() {
        return pinInputSizes;
    }
});
var _react = _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var pinInputVariants = [
    "outline",
    "flushed"
];
var pinInputSizes = [
    "s",
    "m",
    "l"
];
